module.exports = __webpack_public_path__ + "wunderground-logo-84b3fe0be5d629c9381020f6b201fab5.png";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/img/wunderground-logo.png
// module id = 506
// module chunks = 0